module.exports = {
  messages: {
    CN: {
      SequentialExecution: "顺序执行",
      SequentialExecutionDesc:
        "一次专注于一个活动。只有队列中的第一个活动完成后，下一个才会自动开始。",
      HowItWorks: "工作原理",
      SequentialWarning: "队列中靠后的活动可能需要等待很长时间才能开始运行。",
      EqualDistribution: "平均分配",
      EqualDistributionDesc:
        "同时运行所有活动。每日限额在所有活跃活动之间平均分配。",
      DailyLimit: "每日限额",
      requests: "请求",
      ActiveCampaigns: "活跃活动",
      campaigns: "个活动",
      EachCampaignGets: "每个活动获得",
      requestsPerDay: "请求/天",
      EqualInfo: "所有活动一起推进，但每个活动的运行速度比顺序模式慢。",
      campaignA: "活动 A",
      campaignB: "活动 B",
      campaignC: "活动 C",
      perDay: "个/天",
      running: "运行中 ●",
      then: "然后",
      waiting: "等待中",
    },

    US: {
      SequentialExecution: "Sequential Execution",
      SequentialExecutionDesc:
        "Focus on one campaign at a time. Only the first campaign in the queue runs until completed, then the next one starts automatically.",
      HowItWorks: "HOW IT WORKS",
      SequentialWarning:
        "Campaigns lower in the queue may wait a long time before they start running.",
      EqualDistribution: "Equal Distribution",
      EqualDistributionDesc:
        "Run all campaigns at the same time. The daily limit is split equally among all active campaigns.",
      DailyLimit: "Daily Limit",
      requests: "requests",
      ActiveCampaigns: "Active Campaigns",
      campaigns: "campaigns",
      EachCampaignGets: "Each campaign gets",
      requestsPerDay: "requests / day",
      EqualInfo:
        "All campaigns progress together, but each one runs slower than sequential mode.",
      campaignA: "Campaign A",
      campaignB: "Campaign B",
      campaignC: "Campaign C",
      perDay: "/day",
      running: "Running ●",
      then: "then",
      waiting: "Waiting",
    },

    AR: {
      SequentialExecution: "التنفيذ التسلسلي",
      SequentialExecutionDesc:
        "ركز على حملة واحدة في كل مرة. يتم تشغيل الحملة الأولى في قائمة الانتظار حتى تكتمل، ثم تبدأ التالية تلقائيًا.",
      HowItWorks: "كيف يعمل",
      SequentialWarning:
        "قد تنتظر الحملات الأقل في قائمة الانتظار وقتًا طويلاً قبل أن تبدأ في التشغيل.",
      EqualDistribution: "التوزيع المتساوي",
      EqualDistributionDesc:
        "تشغيل جميع الحملات في نفس الوقت. يتم تقسيم الحد اليومي بالتساوي بين جميع الحملات النشطة.",
      DailyLimit: "الحد اليومي",
      requests: "طلبات",
      ActiveCampaigns: "الحملات النشطة",
      campaigns: "حملات",
      EachCampaignGets: "كل حملة تحصل على",
      requestsPerDay: "طلب / يوم",
      EqualInfo:
        "تتقدم جميع الحملات معًا، لكن كل حملة تعمل بشكل أبطأ من وضع التنفيذ التسلسلي.",
      campaignA: "الحملة أ",
      campaignB: "الحملة ب",
      campaignC: "الحملة ج",
      perDay: "/يوم",
      running: "قيد التشغيل ●",
      then: "ثم",
      waiting: "في الانتظار",
    },
  },
};
